

















































































import Vue from "vue";
import { Advertiser } from "../../../interfaces/advertiser";
import { UserLogin } from "../../../interfaces/userlogin";
export default Vue.extend({
  mounted() {
    this.loadAdvertiser();
  },
  methods: {
    async loadAdvertiser() {
      this.advertiser = await this.$store.dispatch(
        "reloadResource",
        "/api/adv/clients/" + this.$route.params.id
      );
      this.userLogin = await this.$store.dispatch(
        "loadResource",
        this.advertiser.owner
      );
      this.isLoading = false;
    }
  },
  data(): {
    advertiser: Advertiser;
    userLogin: UserLogin;
    isLoading: boolean;
  } {
    return {
      isLoading: true,
      advertiser: {},
      userLogin: {}
    };
  }
});
